window.onDomLoad(function () {
  const htmlForm = document.querySelector(
    "[data-behavior='enforce-sso-access-form']"
  ) as HTMLFormElement

  if (!htmlForm) {
    return
  }

  class EnforceSsoAccessConfigurationForm {
    form: HTMLFormElement
    submitButton: HTMLInputElement
    currentValue: string
    translation_scope = 'user.firm_level_configuration.enforce_sso_access'

    constructor(htmlForm: HTMLFormElement) {
      this.form = htmlForm
      this.submitButton = htmlForm.querySelector(
        "input[type='submit']"
      ) as HTMLInputElement
      this.currentValue = this.checkedValue

      this.init()
    }

    init(): void {
      this.submitButton.disabled = true
      this.form.addEventListener('submit', this.onSubmit.bind(this))
      this.form.addEventListener('change', this.onChange.bind(this))
    }

    onSubmit(event: SubmitEvent): void {
      event.preventDefault()

      this.openModal()
    }

    openModal(): void {
      window.modalCitizen.openModal('users-enforce-sso-access-confirm-modal', {
        form: this.form,
        newSetting: this.checkedValue,
        submitButton: this.submitButton,
      })
    }

    onChange(): void {
      if (this.currentValue === this.checkedValue) {
        this.submitButton.disabled = true

        return
      }

      this.submitButton.disabled = false
    }

    get checkedValue(): string {
      const input = this.form.querySelector('input:checked') as HTMLInputElement

      return input.value
    }
  }

  new EnforceSsoAccessConfigurationForm(htmlForm)
})
